import { useContext, useEffect, useState } from "react";
import { GlobalAlertContext } from "../../../../contexts/GlobalAlertContext";
import { AuthContext } from "../../../../contexts/AuthContext";
import { api } from "../../../../services/api";
import useGetEnterprise from "../useGetEnterprise";

export default function useFilter() {

	const { handleToast, handleLoading } = useContext(GlobalAlertContext);
	const [groupsSelected, setGroupsSelected] = useState([]);
	const { user } = useContext(AuthContext)
	const [report1, setReport1] = useState([])
	const [report2, setReport2] = useState([])
	const [report3, setReport3] = useState([])
	const [resumo, setResumo] = useState([])
	const [devedor, setDevedor] = useState([])
	const [contrato, setContrato] = useState([])
	const [estagio, setEstagio] = useState([])
	const [motivo, setMotivo] = useState([])
	const [saldo, setSaldo] = useState([])
	const [valor_original, setValorOriginal] = useState([])
	const [header, setHeader] = useState([])

	const { getEnterpriseById } = useGetEnterprise()

	const [filter, setFilter] = useState({ enterpriseSelected: [] })

	const [height, setHeight] = useState("45%")

	const handleFilter = async (enterpriseSelectedObj) => {
		setGroupsSelected(enterpriseSelectedObj)



		const ids = enterpriseSelectedObj.map(el => {
			return el.id
		})
		localStorage.setItem("clientIdPdfEstatistico", JSON.stringify(ids));
		localStorage.setItem(
			"PreviewPDFenterprise",
			JSON.stringify(ids)
			);
			
			const response = await getEnterpriseById({ids})
			const enterprise = []
			if(enterpriseSelectedObj){
				enterpriseSelectedObj?.map(el => {
					const company = response?.find(item => el.id === item.cre_id)
					if(!!company){
						enterprise.push(company)
					}
				})
			}

			setHeader(enterprise)
			localStorage.setItem("PreviewPDFClient", JSON.stringify(enterprise));
		if (!enterpriseSelectedObj.length) {

			setReport1([])
			setReport2([])
			setReport3([])
			setResumo([])
			return
		}
		if ((typeof enterpriseSelectedObj === 'undefined') || (enterpriseSelectedObj == 'undefined')) {
			return
		}
		try {
			var enterpriseSelected = enterpriseSelectedObj?.map(a => a.id);
		} catch {
			return
		}

		if (Object.keys(enterpriseSelected).length) {
			let data = {
				id_client: enterpriseSelected
			}
			setFilter({ enterpriseSelected: enterpriseSelected, dateStart: data.begin, dateEnd: data.end });
			// handleLoading(true);
			getResumo2(data, enterpriseSelected)
			// getFinancial(data, enterpriseSelected)
			// getBaixas(data, enterpriseSelected)
			// getAcordos(data, enterpriseSelected)
			// getResumo(data, enterpriseSelected)
		}


	};

	const getFinancial = async (data) => {

		try {
			const { data: response } = await api({
				method: "POST",
				url: "/source/dashboard/financial",
				data

			});
			setReport1(response)

		} catch (err) {
			handleToast(true, err.response.data.toast, err.response.data.message);
		}
	}

	const getBaixas = async (data) => {

		try {
			const { data: response } = await api({
				method: "POST",
				url: "/source/dashboard/baixas",
				data
			});
			setReport2(response)
		} catch (err) {
			handleToast(true, err.response.data.toast, err.response.data.message);
		}
	}

	const getAcordos = async (data) => {
		try {
			const { data: response } = await api({
				method: "POST",
				url: "/source/dashboard/acordos",
				data
			});
			setReport3(response)

		} catch (err) {
			handleToast(true, err.response.data.toast, err.response.data.message);
		}
	}

	const getResumo = async (data, enterpriseSelected) => {
		try {
			const idClient = enterpriseSelected
			let data = {
				id_client: idClient
			}
			const { data: response } = await api({ method: 'POST', url: '/source/resumo', data });
			setResumo(response)
			handleLoading(false);

		} catch (err) {
			handleToast(true, err.response.data.toast, err.response.data.message);
		}

	}

	const getResumo2 = async (data, enterpriseSelected) => {
		handleLoading(true);
		try {
			const idClient = enterpriseSelected
			let data = {
				id_client: idClient
			}
			const { data: response } = await api({ method: 'POST', url: '/source/resumo', data });

			const resultados = response?.resultados
			const baixas = response?.baixas
			const total = response?.total
			const resumo = response?.resumo
			const devedor = response?.devedor
			const contrato = response?.contrato
			const motivo = response?.motivo
			const estagio = response?.estagio
			const saldo = response?.saldo
			const valor_original = response?.valor_original
			setReport1(total)
			setReport2(baixas)
			setReport3(resultados)
			setResumo(resumo)
			setDevedor(devedor)
			setContrato(contrato)
			setMotivo(motivo)
			setEstagio(estagio)
			setSaldo(saldo)
			setValorOriginal(valor_original)
			
		} catch (err) {
			handleToast(true, err.response.data.toast, err.response.data.message);
		}
		handleLoading(false);

	}

	return {
		groupsSelected,
		handleFilter,
		filter,
		header,
		report1,
		report2,
		report3,
		resumo,
		setHeight,
		height,
		devedor,
		contrato,
		estagio,
		motivo,
		saldo,
		valor_original
	}
}